<!--
<div class="grid grid-cols-1 lg:grid-cols-2 grid-flow-row gap-6 w-full mt-8 sm:mt-4">
<div class="flex flex-col flex-auto">
  <div class="flex flex-col flex-auto" #demoYouTubePlayer>
 <iframe title="lecteur video" [src]="selectedVideo| Safe" [width]="videoWidth" [height]="videoHeight" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen allowfullscreen></iframe>  
 <img [alt]="'image video'"
 class=" w-60 h-30 cursor-pointer border-4 border-black	"
 src="assets/irbe7/VideoEducatives/gb3biuvkqh4g.webp"/>
  </div>
</div>
<div class="flex flex-col">
  <div class="flex-auto grid grid-cols-4 gap-4"  > 
    <div
      class="col-span-2 flex flex-col items-center justify-center" *ngFor="let video of videos">
      <div class="relative ">
    <img *ngIf="video.id === videoId" [alt]="'image video'"
    class=" w-60 h-30 cursor-pointer border-4 border-black	"
    src="assets/irbe7/VideoEducatives/{{ video.id }}.webp"
    (click)="this.lire(video.id)"/>
    <img *ngIf="video.id != videoId" [alt]="'image video'"
    class=" w-60 h-30 cursor-pointer"
    src="assets/irbe7/VideoEducatives/{{ video.id }}.webp"
    (click)="this.lire(video.id)"/>
    <div class="absolute top-0 right-0">
      <mat-icon svgIcon="mat_solid:play_arrow" class=" bg-[#FDBE01] icon-size-10 fill-white p-2 "></mat-icon>
    </div>
  </div>
    </div>
  </div>
</div>
</div>-->
<div
  class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 w-full min-w-0 bg-card rounded-2xl"
>
  <div
    class="flex flex-col flex-auto col-span-1 overflow-hidden"
    *ngFor="
      let videoE of videosEducatives.slice().reverse()
        | slice
          : (videosEducatives?.length > 3 ? videosEducatives.length - 3 : 0)
    "
  >
    <div class="relative flex flex-col max-w-80 w-full">
      <img
        class="object-cover cursor-pointer max-w-80 max-h-80"
        [routerLink]="['/emission', videoE.nom | convertToSlug, videoE.id]"
        src="assets/irbe7/VideoEducatives/{{ videoE.id }}.webp"
        alt="Card cover image"
      />
      <div class="absolute top-0 right-0">
        <mat-icon
          svgIcon="mat_solid:play_arrow"
          class="bg-[#f4900c] icon-size-10 fill-white p-2"
        ></mat-icon>
      </div>
      <div class="m-2">
        <a
          [routerLink]="['/emission', videoE.nom | convertToSlug, videoE.id]"
          class="text-lg font-semibold leading-tight cursor-pointer hover:text-[#4524CB] hover:underline"
        >
          {{ videoE.nom }}
        </a>
      </div>
    </div>
  </div>
</div>
